module.exports = "/images/mer.png?125c8fbe064bb5eb2f5fe9dd98d4a031";